import React, { useEffect, useMemo, useState } from "react";
import { Alert, Box, Button } from "@mui/material";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import automationServices from "app/services/automations/automation-services";
import AutomationsHeader from "./components/AutomationsHeader";
import { getAutomationType } from "./types";

// Crear (/automations/rules/new/<tipo>) o editar (/automations/rules/<tipo>/<id>) una automatización: busca el tipo en el
// registro y muestra su editor. Query: ?duplicate=<id> para duplicar, ?device_id= (reglas) y ?actuator_id= (controles)
// para llegar con el dispositivo elegido. Al guardar o cancelar vuelve a quien lo abrió (la lista con sus filtros o el
// panel de un equipo).
const AutomationEditorPage = ({ setAssistantContext }) => {
    const { type: typeKey, id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [groupOptions, setGroupOptions] = useState([]);
    const type = getAutomationType(typeKey);
    const query = useMemo(() => Object.fromEntries(searchParams.entries()), [searchParams]);
    const backTo = location.state?.from || "/automations/rules";

    useEffect(() => {
        let active = true;
        automationServices.getAutomationGroups().then((groups) => { if (active) setGroupOptions(groups); }).catch(() => {});
        return () => { active = false; };
    }, []);

    if (!type) {
        return (
            <>
                <AutomationsHeader />
                <Alert severity="warning" action={<Button color="inherit" size="small" onClick={() => navigate("/automations/rules")}>Volver</Button>}>
                    Este tipo de automatización no está disponible en esta versión.
                </Alert>
            </>
        );
    }

    const Editor = type.Editor;
    const back = () => navigate(backTo);

    return (
        <>
            <AutomationsHeader />
            <Box sx={{ pb: 10 }}>
                {/* key: un borrador nuevo del asistente sobre la misma ruta vuelve a armar el editor desde cero. */}
                <Editor
                    key={location.key}
                    id={id}
                    duplicateFromId={query.duplicate}
                    query={query}
                    assistantDraft={location.state?.assistantDraft}
                    groupOptions={groupOptions}
                    onSaved={back}
                    onCancel={back}
                    setAssistantContext={setAssistantContext}
                />
            </Box>
        </>
    );
};

export default AutomationEditorPage;
